import React, { useState } from 'react'
import WaitlistModal from '../WaitlistModal';
import { TbLoader, TbLoader2, TbLoader3, TbLoaderQuarter } from 'react-icons/tb';

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  children = <></> as any, 
  onClick = undefined as any,
  disabled = false,
  loading = false,
  ...rest
}) {
  
  const [ openModal, setOpenModal ] = useState(false);

  const getStyles = () => {
    switch (variant) {
      case "primary":
        return "text-black disabled:!text-black !border border-black bg-primary-300 disabled:!bg-primary-300 transition-all hover:text-white hover:bg-black hover:border-primary-300"
      case "secondary":
        return "text-white disabled:!text-white !border border-white bg-black disabled:!bg-black transition-all hover:text-black hover:bg-primary-300 hover:border-black"
      case "plain":
        return "bg-transparent disabled:!bg-transparent !rounded-none";
      case "link":
        return "bg-transparent disabled:!bg-transparent border-b border-white !rounded-none";
      case "outline":
        return "text-black disabled:!text-black !border border-black bg-transparent disabled:!bg-transparent transition-all hover:text-white hover:bg-black hover:border-primary-300"
      case "ai":
        return "text-white disabled:!text-white bg-gradient-to-br bg-gradient-to-r from-purple-500 to-pink-500 transition-all hover:text-white hover:bg-black hover:border-primary-300"
      case "white":
        return "text-black disabled:!text-black bg-white"
    }
  }

  const getSize = () => {
    switch (size) {
      case "xs":
        return "text-xs rounded-lg px-2 !py-1.5";
      case "sm":
        return "text-sm rounded-lg px-5 py-1.5";
      case "lg":
        return "text-base px-6 py-3 rounded-2xl"
      case "xl":
        return "text-2xl px-6 py-3 rounded-2xl";
    }
  }

  const handleOnDefaultClick = () => {
    // setOpenModal(true);
    // window.open("https://meet.brevo.com/pipelime/drive-more-sales", "_blank");
    window.location.href = "https://app.pipelime.ai";
  }

  onClick = !onClick
    ? handleOnDefaultClick
    : onClick;

  return (<>
    <button 
      className={`border-0 !ring-0 !outline-0 py-2.5 px-4 rounded-lg ${getSize()} ${getStyles()} ${className} disabled:cursor-not-allowed disabled:opacity-50`}
      disabled={loading || disabled}
      onClick={onClick}
      {...rest}
    >
      {loading 
        ? <div className='flex items-center justify-center gap-2'>
            <TbLoader2 className='animate-spin' />
            <div>
              {children}
            </div>
          </div>
        : children
      }
    </button>
    {openModal && <WaitlistModal close={() => setOpenModal(false)} /> }
  </>
  )
}
